import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Typography, Icon, Button, Modal, Row, Col, Carousel } from 'antd'

const { Text } = Typography

const steps = [
  {
    text:
      'Personalize os textos editáveis com as informações que você quiser, como o nome do seu amigo(a).',
  },
  {
    text:
      'Opcionalmente pesquise um GIF que será utilizado para deixar ainda mais legal sua personalização!',
  },
  {
    text:
      'Digite o email do seu amigo(a) e uma mensagem que será enviada no corpo do email.',
  },
  {
    text:
      'Clique em "Enviar" e pronto! Seu amigo(a) receberá o presente por email em instantes.',
  },
]

export function GiftPageTutorial({ handleOk, handleHide, isVisible }) {
  const [currentStep, setStep] = useState(0)
  let slider = null

  return (
    <Modal
      title={
        <Fragment>
          <Icon type='info-circle' style={{ fontSize: 18, marginRight: 10 }} />
          <Text>
            Como utilizar a <strong>Caixa de Presente</strong>
          </Text>
        </Fragment>
      }
      type='info'
      visible={isVisible}
      cancelText='Não mostrar novamente'
      onOk={handleOk}
      onCancel={handleHide}
      closable={false}
    >
      <Row style={{ padding: '20px 0' }}>
        <Carousel ref={node => (slider = node)} dots={false}>
          {steps.map((_, index) => (
            <Fragment key={index}>
              <Col span={3}>
                <Text style={{ fontSize: 26 }}>{index + 1}</Text>
              </Col>
              <Col span={21}>
                <Text style={{ fontSize: 16 }}>{steps[index].text}</Text>
              </Col>
            </Fragment>
          ))}
        </Carousel>
      </Row>

      <Button
        onClick={() => {
          slider.next()
          setStep((currentStep + 1) % 4)
        }}
        className='btn-secondary'
        type='primary'
        block
        style={{ marginTop: 50 }}
      >
        Próximo
        <Icon type='right' />
      </Button>
    </Modal>
  )
}

GiftPageTutorial.propTypes = {
  /** Callback to be executed when the "OK" button is clicked */
  handleOk: PropTypes.func,

  /** Callback to be executed when the "Não mostrar novamente" button is clicked */
  handleHide: PropTypes.func,

  /** Whether the modal is visible or not */
  isVisible: PropTypes.bool,
}
